'use client'

import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { AppCard } from '@/shared/ui'

export function MaintenancePage() {
  const { t } = useTranslation()

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="bg"
      p={{ base: 4, md: 8 }}
    >
      <AppCard.Root maxW="540px" w="full">
        <AppCard.Body p={{ base: 6, md: 8 }}>
          <VStack gap={4} textAlign="center">
            <Box
              px={3}
              py={1}
              borderRadius="full"
              bg="primary.subtle"
              color="primary.fg"
              fontSize="xs"
              fontWeight="semibold"
              letterSpacing="0.04em"
              textTransform="uppercase"
            >
              {t('maintenance.badge')}
            </Box>
            <Heading size="lg" color="fg">
              {t('maintenance.title')}
            </Heading>
            <Text color="fg.muted" fontSize="sm" lineHeight={1.7}>
              {t('maintenance.description')}
            </Text>
          </VStack>
        </AppCard.Body>
      </AppCard.Root>
    </Flex>
  )
}
